import { sortSectorNames } from "@/lib/sectorSort";

export const SECTORS = sortSectorNames([
  "Absolute Return", "Alternative Assets", "American Emerging Equities", "Asia Pacific Emerging Equities",
  "Asia Pacific Ex China, India & AUS", "Australia", "China", "Emerging Market Fixed Income",
  "Energy", "European Emerging Equities", "European Equities", "Global Corporate Fixed Interest Other",
  "Global Emerging Market Equities", "Global Government Fixed Interest Other", "Global High Yield ex Emerging Market",
  "Global Property", "Global Short Duration", "India", "Japanese Equities", "Metals", "Money Market",
  "North American Equities", "North American Fixed Corporate Interest", "North American Fixed Gov Interest",
  "UK Corporate Fixed Interest", "UK Gilts", "UK High Yield", "UK Index-Linked", "UK Large Cap",
  "UK Mid Cap", "UK Small Cap", "UK Property", "UK Short Duration",
]);

export const BENCHMARKS = [1, 2, 3, 4, 5];

export interface FundHouse { id: string; benchmark: number; name: string; sort_order: number; factsheet_as_of?: string | null; }
export interface Allocation { id: string; benchmark: number; sector_name: string; fund_house_id: string; weight_pct: number; }
export interface Holding { id: string; fund_house_id: string; holding_name: string; sort_order: number; holding_weight_pct: number; isin?: string | null; updated_at?: string | null; }
export interface Mapping { id: string; holding_id: string; cbam_sector_name: string; weight_pct: number; }
